import React, { forwardRef } from 'react';
import { Picture, Button } from '@ui';
import { delikatescaHero } from '@images';
import Breadcrumbs from '@components/Breadcrumbs';
import useWindowSize from '@customHooks/useWindowSize';
import './styles.scss';

const breadCrumbsArray = [
  { title: 'Главная', url: '/' },
  { title: 'Устричные бары в Москве', url: '' }
];

const Delikatesca = forwardRef<HTMLElement>((props, ref) => {
  const { isDesktop } = useWindowSize();
  const scrollToSection = (sectionId: string): void => {
    const section = document.getElementById(sectionId);
    if (section) {
      const header = document.querySelector('.header-main') as HTMLElement;
      const headerHeight = header ? header.offsetHeight : 104;
      const sectionTop = section.offsetTop - headerHeight;

      window.scrollTo({
        top: sectionTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section ref={ref} className='delikatesca'>
      <div className='delikatesca__container'>
        <div className='delikatesca__content'>
          <div className='pl-15 sm:pl-4 md:pl-8 text-[var(--main-font-color)] fromLg:mb-7 md:pt-2 sm:pt-4'>
            <Breadcrumbs
              array={breadCrumbsArray}
              withoutBackBtn
              isDesktop={isDesktop}
              noPaddingMobile
            />
          </div>
          <div className='delikatesca__text-block'>
            <p className='delikatesca__title oysterbar-test-title'>
              Деликатеска
            </p>
            <h1 className='delikatesca__subtitle'>
              <span className='delikatesca__subtitle-line'>
                Устричные бары у дома
              </span>
              <span className='delikatesca__subtitle-line'>
                Широкий выбор морепродуктов,
              </span>
              <span>вино, честные цены</span>
            </h1>
            <div className='delikatesca__buttons'>
              <Button
                type='btn'
                size='large'
                colour='red'
                rank='primary'
                text='Адреса'
                onClick={() => {
                  scrollToSection('addresses');
                }}
              />
              <Button
                type='btn'
                size='large'
                colour='grey'
                rank='secondary'
                text='Забронировать'
                onClick={() => {
                  scrollToSection('booking');
                }}
              />
              <Button
                type='btn'
                size='large'
                colour='grey'
                rank='secondary'
                text='Доставка'
                onClick={() => {
                  scrollToSection('delivery-from-gastrobar');
                }}
              />
            </div>
          </div>

          <div className='delikatesca__image-block'>
            <Picture icon={delikatescaHero} />
          </div>
        </div>
      </div>
    </section>
  );
});

export default Delikatesca;
